import { Toggle } from '@warp-ds/react';
import cn from 'classnames';
import type { ReactNode } from 'react';
import type { PrepackageDestination } from '../../types';

type DestinationPickerToggleProps = {
    destination: PrepackageDestination;
    label: ReactNode;
    checked: boolean;
    indeterminate?: boolean;
    disabled: boolean;
    onToggle: (destination: PrepackageDestination) => void;
    className?: string;
};

export const DestinationPickerToggle = ({
    destination,
    label,
    checked,
    indeterminate = false,
    disabled,
    onToggle,
    className,
}: DestinationPickerToggleProps) => (
    <div className={cn('py-6', className)}>
        <Toggle
            type="checkbox"
            label={label}
            checked={checked}
            indeterminate={indeterminate}
            disabled={disabled}
            onChange={() => onToggle(destination)}
        />
    </div>
);
